import { schema } from "normalizr";
import segmentSchema from "./segment";

const driverQuoteSchema = new schema.Entity(
    "driverQuotes",
    {
        segmentIds: [segmentSchema]
    },
    { idAttribute: "id" }
);

export default driverQuoteSchema;



// WEBPACK FOOTER //
// ./src/schemas/driverQuote.js